import { useState } from "react";

export const useHeaderModals = () => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isLeagueSwitcherOpen, setIsLeagueSwitcherOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileProfileOpen, setIsMobileProfileOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);

  return {
    isSubmenuOpen,
    setIsSubmenuOpen,
    isProfileOpen,
    setIsProfileOpen,
    isLeagueSwitcherOpen,
    setIsLeagueSwitcherOpen,
    isNotificationOpen,
    setIsNotificationOpen,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    isMobileProfileOpen,
    setIsMobileProfileOpen,
    isMobileSearchOpen,
    setIsMobileSearchOpen,
    showSupportModal,
    setShowSupportModal,
  };
};
